import { SpinnerModule } from "./../spinner/spinner.module";
import { TransitionModule } from "./../transition/transition.module";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonComponent } from "./button.component";
import { IconModule } from "../icon/icon.module";
import { RouterModule } from "@angular/router";

@NgModule({
	declarations: [ButtonComponent],
	imports: [IconModule, CommonModule, TransitionModule, SpinnerModule, RouterModule],
	exports: [ButtonComponent]
})
export class ButtonModule { }
